// 导入组件
import CategoryDescription from './components/category-description';

(function ($) {
  "use strict";

  class App {
    constructor() {
      this.init();
    }

    init() {
      console.log("Main script initialized");
      this.applyCustomColors();
      this.initComponents();
    }

    applyCustomColors() {
      const customColors = window.customColors || {};
      const root = document.documentElement;

      for (const [key, value] of Object.entries(customColors)) {
        if (value) {
          root.style.setProperty(`--${key}`, value);
        }
      }
    }

    initComponents() {
      // 检查并初始化导航
      if (typeof window.Navigation !== "undefined") {
        console.log("Initializing Navigation");
        new window.Navigation();
      }

      // 检查并初始化用户菜单
      if (typeof window.UserMenu !== "undefined") {
        console.log("Initializing UserMenu");
        new window.UserMenu();
      }

      // 检查并初始化个人资料页面
      if (typeof window.Profile !== "undefined") {
        console.log("Initializing Profile");
        new window.Profile();
      }

      // 检查并初始化游戏播放器
      console.log("Main: Checking for GamePlayer component");
      if (typeof window.GamePlayer !== "undefined") {
        console.log("Main: GamePlayer class found, initializing...");
        new window.GamePlayer();
      } else {
        console.warn("Main: GamePlayer class not found!");
      }

      // 检查并初始化回到顶部
      console.log("Main: Checking for BackToTop component");
      if (typeof window.BackToTop !== "undefined") {
        console.log("Main: BackToTop class found, initializing...");
        new window.BackToTop();
      }

      // 检查并初始化 AuthManager
      if (typeof window.AuthManager !== "undefined") {
        console.log("Initializing AuthManager");
        if (!window.authManager) {
          try {
            window.authManager = new window.AuthManager();
          } catch (error) {
            console.error("Failed to initialize AuthManager:", error);
          }
        }
      } else {
        console.warn("AuthManager not found!");
      }

      // 初始化分类描述组件
      if (document.querySelector('.category-description')) {
        console.log('Initializing CategoryDescription');
        new CategoryDescription();
      }

      console.log("Components initialization completed");
    }
  }

  // 等待 DOM 和所有脚本加载完成
  $(window).on('load', () => {
    window.GameHub = new App();
  });
})(jQuery);
